export var PAGE_KEY = 'crehana-library-hana-ai-chip';